var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('component-header'),_vm._v(" "),_c('div',{attrs:{"id":"content"}},[_c('section',{attrs:{"id":"banner"}},[_c('div',{staticClass:"row"},[_c('router-view')],1)])]),_vm._v(" "),_c('component-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82e8810a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/pages/Orderpoint/Template/template.html
// module id = 218
// module chunks = 0